export const contractTypes = {
  SIMPLE: 'SIMPLE',
  SPECIFIC: 'SPECIFIC',
}
